export default class MapsApi {
  async getCoordenates (address) {
    const result = await window.jQuery.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyBmTUslC1hIV4-mZIUnsQ2HJol0wPyH4H8`)
    return result
  }
}
